import { createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";

const initialState = {
  isMultilot: false,
  isCooperative: false,
  isShowPurchaseFields: false,
};

const purchaseSlice = createSlice({
  name: "purchaseSlice",
  initialState,
  reducers: {
    setMultilot(state) {
      const message = `${!state.isMultilot ? "Включены" : "Выключены"} мультилотовые закупки`;

      state.isMultilot ? notification.error({ message }) : notification.success({ message });
      state.isMultilot = !state.isMultilot;
    },
    setCooperative(state) {
      const message = `${
        !state.isCooperative ? "Включены" : "Выключены"
      } многобенефициарные закупки`;

      state.isCooperative ? notification.error({ message }) : notification.success({ message });
      state.isCooperative = !state.isCooperative;
    },
    setShowPurchaseFields(state, action) {
      state.isShowPurchaseFields = action.payload;
    },
  },
});

export const { setMultilot, setCooperative, setShowPurchaseFields } = purchaseSlice.actions;
export const isMultilot = (state) => state.purchase.isMultilot;
export const isCooperative = (state) => state.purchase.isCooperative;
export const isShowPurchase = (state) => state.purchase.isShowPurchaseFields;

export default purchaseSlice.reducer;
